module.exports = function getResource(label, vars = []) {
    let resources = {
        quickLookText: 'Aperçu rapide',
        moreInfoText: `Pour en savoir plus sur ${vars[0]}`
    };

    return resources[label];
};
